import {
    FETCH_GAMEWISE_SALE_FAILURE,
    FETCH_GAMEWISE_SALE_REQUEST,
    FETCH_GAMEWISE_SALE_SUCCESS,
  } from '../actions/gameWiseReportingActions';
  
  const initialState = {
    data: [],
    loading: false,
    error: null,
  };
  
  export const gameWiseSaleReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GAMEWISE_SALE_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_GAMEWISE_SALE_SUCCESS:
        console.log('action>>', action);
        return { ...state, loading: false, data: action.payload };
      case FETCH_GAMEWISE_SALE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  